import React, { memo } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { t } from 'i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useFormSubmit from 'hooks/useFormSubmit';
import { useAppInfo } from 'context';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormFileUploadField from 'components/ui/form/FormFileUploadField';
import FormTextField from 'components/ui/form/FormTextField';

const validationSchema = yup.object({
  title: yup.string().required('lead.addEditModal.validation.comment'),
});

export default memo(function TaskCreateModal({ open, setOpen, leads }) {
  const [{ refetchTaskCount }] = useAppInfo();
  const { submit, isSubmitting } = useFormSubmit();
  const formik = useFormik({
    initialValues: {
      audio: '',
      title: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (leads?.length) {
        const body = { ...values, leads };
        submit(
          { type: 'post', contentType: 'simple' },
          body,
          '/crm/crm-lead/auto-call',
          'add auto call',
          null,
          true,
          () => {
            refetchTaskCount?.();
            setOpen(null);
            formik.resetForm();
          }
        );
      }
    },
  });

  const onClose = () => {
    setOpen(null);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none !overflow-hidden' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-[#CDCDCDC7] !text-center !border-b !border-b-[#E6E6E6]'
      >
        <span className='pr-5 font-semibold text-[21px] text-[#374957]'>
          {t('common.button.autoCall')}
        </span>
      </DialogTitle>
      <div className='py-4 px-8 min-w-[600px]'>
        <form onSubmit={formik.handleSubmit}>
          <div className='flex justify-center flex-col gap-4'>
            <div className='-mb-1 text-gray-600 text-sm'>
              {t('common.button.uploadAudio')}
            </div>
            <FormFileUploadField
              delay={0.0012}
              accept='.mp3,.wav,.ogg,.aac,.m4a'
              fieldName='audio'
              formik={formik}
              label={t('common.button.uploadAudio')}
              btnLabel={t('common.button.uploadAudio')}
              fileSize={10}
            />
            <FormTextField
              delay={0}
              label={t('common.fields.comment')}
              fieldName='title'
              rows={3}
              multiline={true}
              formik={formik}
            />
            <div className='flex justify-between items-center'>
              <div>
                {t('sidebar.admin.lead')}: {leads?.length}
              </div>
              <FormActionButtons
                delay={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
});
